module.exports = __webpack_public_path__ + "img/checkin_at_airport.2e4e952e.png";